import styled from 'styled-components'
import { headerStatStyles, chartWrapperStyles } from '../dynamic-widget/styled'
import { tokens } from '../../../assets/tokens'

const TableStatisticStyled = styled.div`
  && {
    padding: ${props => (props.isDashboard ? 0 : "30px 0")};
    height: ${props => (props.inheritHeight ? "auto" : "inherit")};
  }
  
  ${headerStatStyles}
  
  ${chartWrapperStyles}

  /* La tabla va dentro de la tarjeta con aire: su cabecera redondeada ya no choca con el borde */
  .chart-wrapper {
    display: block;
    padding: 16px;
    z-index: 0;
    height: ${props => props.inheritHeight ? "auto" : (props.customHeight ? props.customHeight : '300px')};
    max-height: ${props => props.maxHeight ? `${props.maxHeight.replace('px', '')}px` : 'initial'};
    overflow-y: auto;
  }

  .MuiTableHead-root {
    th {
      span {
        line-height: 12px;
      }
    }
  }

  /* Celdas 13/400 como las tablas de la ficha, sin negritas */
  .MuiTableBody-root {
    tr:first-child td,
    tr td {
      height: 48px;
      padding-top: 8px;
      padding-bottom: 8px;
      font-size: 13px;
      font-weight: 400;
      color: ${tokens.color.text.secondary};

      span {
        font-weight: 400;
        line-height: 18px;
      }

      .cell-icon {
        display: inline-flex;
        vertical-align: middle;
      }
    }
  }
`

export default TableStatisticStyled
